import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
// import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import posthog from "posthog-js";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import {
  getValidMapCenter,
  renderWithBold,
  toastUtils,
  useQuestCategories,
} from "../../../Utils/helper";
import Button from "../../../components/common/Button/Button";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import CommonModal from "../../../components/common/Modal/ModalCommon";
// import ImageSlider from "../../../components/common/SlideShowImage/ImageSlider";
import images from "../../../images";
import {
  useGetUserInfoQuery,
  useLazyGetQuestListPerLocationQuery,
  useLazyGetQuestListQuery,
  usePostFavoriteLocationMutation,
  usePostQrCodeTrackMutation,
  usePostStartQuestMutation,
  useUpdateUserInfoMutation,
} from "../../../services/apiSlice";
import { cn, formatDateToFakeMicroUTC } from "../../../Utils/helper";
// import TipsPerLocation from "./TipsPerLocation/TipsPerLocation";
import TipsReward from "../../../components/common/Tips/TipsReward";
import Dialog from "../../../components/common/Dialog";
import QuestDetails from "../Details/QuestDetails";

import BodyModalLoading from "../../../components/common/Modal/BodyModalLoading/BodyModalLoading";
// import Map, { Marker } from "react-map-gl/mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
import CompletedAllQuest from "./CompletedAllQuest/CompletedAllQuest";
import QuestCategorySection from "./QuestCategorySection/QuestCategorySection";
import { CustomSelect } from "../../../components/common/Select/CustomSelect";
import LoadingSpinner from "../../../components/common/Loading/LoadingSpinner";

// Constants
const API_LIMIT = 15;
const API_LIMIT_STEP = 15;

const QuestPerLocation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id: locationId } = useParams();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const fromQrCode = searchParams.get("from") === "qrcode";
  const autoOpenQuestId = searchParams.get("quest_id");
  const shouldAutoOpen = searchParams.get("auto_open") === "true";
  const location = useLocation();

  const referralCode = sessionStorage.getItem("referralCode") || null;
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");
  const [quests, setQuests] = useState([]);
  const [favorite, setFavorite] = useState(false);
  const [isParticipantsCompleted, setIsParticipantsCompleted] = useState(false);
  const [limit, setLimit] = useState(API_LIMIT);
  const [hasMore, setHasMore] = useState(true);
  const [showCompletedBanner, setShowCompletedBanner] = useState(true);
  const [showTipsReward, setShowTipsReward] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("showQuestRewardTips") !== "false";
    }
    return true;
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ age: "", gender: "" });
  const [errors, setErrors] = useState({ age: "", gender: "" });
  const [showValidationModal, setShowValidationModal] = useState(false);

  const now = new Date();
  const nowUTCISOString = formatDateToFakeMicroUTC(now);
  const nowDate = new Date(nowUTCISOString.slice(0, 23));
  const infomationBizModalRef = useRef(null);

  const [
    getListQuestsPerLocation,
    { isFetching: isFetchingPerLocation, error: errorPerLocation },
  ] = useLazyGetQuestListPerLocationQuery();
  const [getListQuests, { isFetching: isFetchingAuth, error: errorAuth }] =
    useLazyGetQuestListQuery();
  const [favorites, { isLoading: isFavoriteLoading }] =
    usePostFavoriteLocationMutation();
  const [postQrCodeTrack, { isLoading: isQrCodeTracking }] =
    usePostQrCodeTrackMutation();

  const { data: userInfo, refetch: refetchUserInfo } = useGetUserInfoQuery(
    {},
    { skip: !accessToken, refetchOnMountOrArgChange: true },
  );

  const [postStartQuest] = usePostStartQuestMutation();
  const [updateUserInfo] = useUpdateUserInfoMutation();

  // const noop = () => {};

  // -- STATE MỚI CHO DIALOG QUEST --
  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const questDetailDialogRef = useRef();
  const loadingQuestModalRef = useRef(null);
  const locationDialogRef = useRef(null);
  const validateInfomationModelRef = useRef();

  // Load Google Maps API
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  useEffect(() => {
    if (accessToken && userInfo?.data?.id) {
      // Clear existing PostHog data from localStorage
      const posthogStorageKey = `ph_${process.env.REACT_APP_POSTHOG_KEY}_posthog`;
      localStorage.removeItem(posthogStorageKey);

      // Identify user and capture event
      posthog.identify(userInfo.data.id.toString());
      posthog.capture("$identify", { $identified: true });

      // Force an immediate pageview to update session and persist distinct_id
      posthog.capture("$pageview", { path: window.location.pathname });

      // Debug: Log current distinct_id
    } else if (!accessToken) {
    } else {
    }
  }, [userInfo, accessToken]);

  const checkParticipantsStatus = useCallback((data) => {
    if (!data?.data || !Array.isArray(data.data) || data.data.length === 0) {
      setIsParticipantsCompleted(false);
      return;
    }

    const allQuestsCompleted = data.data
      .filter((quest) => quest.quest_business.quota_type === "DAILY")
      .every(
        (quest) =>
          Array.isArray(quest.participants) &&
          quest.participants.length > 0 &&
          quest.participants.length === 2 &&
          quest.participants.every(
            (participant) => participant.status === "COMPLETED",
          ),
      );

    setIsParticipantsCompleted(allQuestsCompleted);
  }, []);

  useEffect(() => {
    if (
      shouldAutoOpen &&
      autoOpenQuestId &&
      quests.length > 0 &&
      !isFetchingPerLocation &&
      !isFetchingAuth
    ) {
      const questExists = quests.some((q) => q.id === autoOpenQuestId);
      if (questExists) {
        setSelectedQuestId(autoOpenQuestId);
        questDetailDialogRef.current?.open();

        // Remove query params after opening
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("quest_id");
        newSearchParams.delete("auto_open");
        navigate(
          {
            pathname: window.location.pathname,
            search: newSearchParams.toString(),
          },
          { replace: true },
        );
      }
    }
  }, [
    shouldAutoOpen,
    autoOpenQuestId,
    quests,
    isFetchingPerLocation,
    isFetchingAuth,
    searchParams,
    navigate,
  ]);
  const optionsAge = useMemo(
    () => [
      { value: "", label: t("signUp.gender.gender") },
      { value: "male", label: t("signUp.gender.male") },
      { value: "female", label: t("signUp.gender.female") },
      { value: "maleIdentifying", label: t("signUp.gender.maleIdentifying") },
      {
        value: "femaleIdentifying",
        label: t("signUp.gender.femaleIdentifying"),
      },
      { value: "nonBinary", label: t("signUp.gender.nonBinary") },
      { value: "agender", label: t("signUp.gender.agender") },
      { value: "preferNotToSay", label: t("signUp.gender.preferNotToSay") },
    ],
    [t],
  );
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleSelectChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, gender: selectedOption.value }));
    setErrors((prev) => ({ ...prev, gender: "" }));
  };
  const handleCloseCompletedBanner = useCallback(() => {
    setShowCompletedBanner(false);
  }, []);

  const handleCloseTipsReward = useCallback(() => {
    setShowTipsReward(false);
    localStorage.setItem("showQuestRewardTips", "false");
  }, []);

  // Function to get user's current location
  const getUserLocation = useCallback(() => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported by this browser"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000, // 5 minutes
        },
      );
    });
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.age || !formData.age.trim()) {
      newErrors.age = t("onBoard.ageRequired") || "Age is required";
    } else {
      const ageNum = parseInt(formData.age);
      if (ageNum < 13 || ageNum > 199) {
        newErrors.age =
          t("onBoard.ageInvalid") || "Age must be between 13 and 120";
      }
    }

    if (!formData.gender) {
      newErrors.gender = t("onBoard.genderRequired") || "Gender is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleValidateInformation = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    try {
      const userData = { age: parseInt(formData.age), gender: formData.gender };
      const response = await updateUserInfo(userData).unwrap();

      if (response.status === 200) {
        setShowValidationModal(false);
        await refetchUserInfo();
        // handleParentStartQuest;
        validateInfomationModelRef.current?.close();

        questDetailDialogRef.current?.open();
      }
    } catch (error) {
      console.error("Error updating info:", error);
      toastUtils.error(
        error?.data?.detail?.[0]?.msg || "Failed to update information",
      );
    } finally {
      setIsSubmitting(false);
      validateInfomationModelRef.current?.close();
    }
  };

  // Function to track QR code scan
  const trackQrCodeScan = useCallback(async () => {
    if (!fromQrCode) return;

    try {
      // Check if we've already tracked this QR code scan in this session
      const trackingKey = `qr_tracked_${locationId}`;
      if (sessionStorage.getItem(trackingKey)) {
        return; // Already tracked in this session
      }

      // Get user's current location
      const location = await getUserLocation();

      // Get current page URL as QR code URL
      const qrCodeUrl = window.location.href;

      // Get consumer ID from user info (null if not authenticated)
      const consumerId =
        accessToken && userInfo?.data?.id ? userInfo.data.id.toString() : null;

      const trackingData = {
        qr_code_url: qrCodeUrl,
        consumer_id: consumerId,
        latitude: location.latitude,
        longitude: location.longitude,
      };

      await postQrCodeTrack(trackingData).unwrap();

      sessionStorage.setItem(trackingKey, "true");
    } catch (error) {
      console.error("Failed to track QR code scan:", error);
    }
  }, [
    fromQrCode,
    accessToken,
    locationId,
    getUserLocation,
    userInfo,
    postQrCodeTrack,
  ]);

  const handleParentStartQuest = async (questId, questDataDetail) => {
    questDetailDialogRef.current?.close();
    if (userInfo?.data?.status !== "active") {
      setShowValidationModal(true);
      validateInfomationModelRef.current?.open();
      return;
    } else {
      loadingQuestModalRef.current?.openModal();

      try {
        const payload = {
          quest_id: questId,
          referral_code: referralCode || "",
        };
        const currentStatus = questDataDetail?.consumer_status;
        let response;

        if (currentStatus === "DOING" || currentStatus === "PAUSED_QUEST") {
          const { data: practiceData } = await postStartQuest(payload);
          response = practiceData;
        } else {
          response = await postStartQuest(payload).unwrap();
        }

        if (response?.status === 200) {
          await new Promise((resolve) => setTimeout(resolve, 6000));

          const isValidationReceipt =
            questDataDetail?.is_receipt_required ?? true;
          const questBusiness = questDataDetail?.quest_business;

          loadingQuestModalRef.current?.closeModal();

          const queryParams = new URLSearchParams({
            quest_id: response.data.quest_id,
            stt_done: response.data.stt_done,
            expired_at: response.data.expired_at,
            quotaType: questBusiness?.quest_type,
            is_validation_receipt: isValidationReceipt,
            location_id: questDataDetail?.location_id,
          }).toString();

          navigate(
            `/quest/details/multiple/choice/${response.data.id}?${queryParams}`,
          );
          sessionStorage.removeItem("referralCode");
          sessionStorage.removeItem("referralInfo");
        } else {
          throw new Error("Invalid response status");
        }
      } catch (err) {
        console.error("Error start quest:", err);
        toastUtils.error(
          err?.data?.detail?.[0]?.msg || t("toast.error.failedToTakeQuest"),
        );
        loadingQuestModalRef.current?.closeModal();
      }
    }
  };

  const saveQrCodeInfoForLaterTracking = useCallback(() => {
    if (!fromQrCode || !locationId) return;

    const qrCodeInfo = {
      locationId,
      qrCodeUrl: window.location.href,
      timestamp: Date.now(),
      fromQrCode: true,
    };

    localStorage.setItem("pending_qr_tracking", JSON.stringify(qrCodeInfo));
  }, [fromQrCode, locationId]);

  const trackQrCodeScanAfterAuth = useCallback(async () => {
    if (!accessToken || !userInfo?.data?.id) return;

    try {
      const pendingQrInfo = localStorage.getItem("pending_qr_tracking");
      if (!pendingQrInfo) return;

      const qrInfo = JSON.parse(pendingQrInfo);

      if (qrInfo.locationId !== locationId || !qrInfo.fromQrCode) return;

      const trackingKey = `qr_tracked_after_auth_${locationId}`;
      if (sessionStorage.getItem(trackingKey)) {
        localStorage.removeItem("pending_qr_tracking");
        return;
      }

      // Get user's current location
      const location = await getUserLocation();

      const trackingData = {
        qr_code_url: qrInfo.qrCodeUrl,
        consumer_id: userInfo.data.id.toString(),
        latitude: location.latitude,
        longitude: location.longitude,
      };

      await postQrCodeTrack(trackingData).unwrap();

      sessionStorage.setItem(trackingKey, "true");
      localStorage.removeItem("pending_qr_tracking");
    } catch (error) {
      console.error("Failed to track QR code scan after auth:", error);
    }
  }, [accessToken, userInfo, locationId, getUserLocation, postQrCodeTrack]);

  const fetchQuests = useCallback(
    async (newLimit, append = false) => {
      if (locationId === null || locationId === "null") {
        navigate("/quest");
        return;
      }
      const params = {
        limit: newLimit,
        id_location: locationId,
        ...(searchQuery.trim() && { search: searchQuery.trim() }),
      };

      try {
        const response = accessToken
          ? await getListQuests(params).unwrap()
          : await getListQuestsPerLocation(params).unwrap();

        const normalizedQuests = (response?.data || []).map((quest) => ({
          ...quest,
          participants: Array.isArray(quest.participants)
            ? quest.participants
            : [],
        }));

        setFavorite(response.favorited);
        setQuests((prev) =>
          append ? [...prev, ...normalizedQuests] : normalizedQuests,
        );
        setHasMore(newLimit < response?.total);
        checkParticipantsStatus({ ...response, data: normalizedQuests });
      } catch (error) {
        console.error("Error fetching quests:", error);
      }
    },
    [
      accessToken,
      locationId,
      searchQuery,
      getListQuests,
      getListQuestsPerLocation,
      checkParticipantsStatus,
      navigate,
    ],
  );

  const handleQuestSaved = useCallback(
    (questId, status) => {
      setQuests([]);
      setLimit(API_LIMIT);
      setHasMore(true);
      fetchQuests(API_LIMIT, false);
    },
    [fetchQuests],
  );

  useEffect(() => {
    setQuests([]);
    setLimit(API_LIMIT);
    setHasMore(true);
    fetchQuests(API_LIMIT, false);
  }, [searchQuery, locationId, fetchQuests]);

  const categories = useQuestCategories(quests);

  useEffect(() => {
    if (fromQrCode && locationId) {
      if (accessToken && userInfo?.data?.id) {
        trackQrCodeScan();
      } else {
        trackQrCodeScan();
        saveQrCodeInfoForLaterTracking();
      }
    }
  }, [
    fromQrCode,
    locationId,
    accessToken,
    userInfo,
    trackQrCodeScan,
    saveQrCodeInfoForLaterTracking,
  ]);

  useEffect(() => {
    if (accessToken && userInfo?.data?.id && fromQrCode && locationId) {
      const pendingQrInfo = localStorage.getItem("pending_qr_tracking");
      if (pendingQrInfo) {
        trackQrCodeScanAfterAuth();
      }
    }
  }, [accessToken, userInfo, fromQrCode, locationId, trackQrCodeScanAfterAuth]);

  const loadMoreIfPossible = useCallback(() => {
    if (!hasMore || isFetchingPerLocation || isFetchingAuth) return;
    setLimit((prev) => {
      const nextLimit = prev + API_LIMIT_STEP;
      fetchQuests(nextLimit, false);
      return nextLimit;
    });
  }, [hasMore, isFetchingPerLocation, isFetchingAuth, fetchQuests]);

  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 100
    ) {
      loadMoreIfPossible();
    }
  }, [loadMoreIfPossible]);
  const firstQuest = useMemo(() => {
    return quests[0] || {};
  }, [quests]);
  const defaultProps = {
    center: { lat: 1.3048205133757569, lng: 103.83302396479785 },
    zoom: 11,
  };
  const containerStyle = {
    width: "100%",
    height: "180px",
    borderRadius: "12px",
    filter: "#EEEAE8",
    transition: "all 0.3s ease-in-out",
  };

  // Horizontal lazy load: load more when any category scroller reaches end
  const handleHorizontalEndReached = useCallback(() => {
    loadMoreIfPossible();
  }, [loadMoreIfPossible]);

  const mapCenter = useMemo(() => {
    const validCenter = getValidMapCenter(firstQuest?.location);
    if (validCenter) {
      return validCenter;
    }
    return defaultProps.center;
  }, [firstQuest, defaultProps.center]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  if (loadError) {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="container mx-auto px-4 py-6">
          <div>
            {t("quest.questDetails.errorLoadingMap") || "Error loading map"}
          </div>
        </div>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="container mx-auto px-4 py-6">
          <LoadingCommon statusLoading={true} />
        </div>
      </div>
    );
  }

  if (errorPerLocation || errorAuth) {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="flex flex-col items-center justify-center p-4">
          <div className="mx-auto px-4 py-6">
            {t("quest.questDetails.errLoadingQuest")}
          </div>
          <hr className="my-[30px]" />
          <Button
            text={"Explore more quests"}
            onClick={() =>
              navigate("/quest", { state: { direction: -1 }, replace: false })
            }
            className={
              "rounded-md border-solid border-[#253FF6] border-[1.5px] text-[#253FF6] text-xl font-medium"
            }
          />
        </div>
      </div>
    );
  }

  if (!Array.isArray(quests) || quests.length === 0) {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="container mx-auto px-4 py-6">
          <LoadingCommon statusLoading={true} />
        </div>
      </div>
    );
  }

  const handleFavoriteLocation = async (locationId) => {
    if (!accessToken) {
      const codeParam = referralCode ? `&code=${referralCode}` : "";
      navigate("/register?from=qrcode&location_id=" + locationId + codeParam);
      return;
    }
    try {
      const respon = await favorites({ location_id: locationId }).unwrap();

      if (respon.status === 200) {
        fetchQuests(limit, false);
      }
    } catch (error) {
      console.error("Failed to favorite location:", error);
    }
  };

  // const handleClick = () => {
  //   if (!accessToken) {
  //     navigate("/register?from=qrcode&location_id=" + locationId);
  //   } else {
  //     navigate("/profile/notifications");
  //   }
  // };

  const handleQuestClick = (quest) => {
    if (!accessToken) {
      const isQuestFull =
        quest.consumer_status === "FULL" || quest.slot_available === 0;
      const isQuestExpired =
        quest.quest_business?.status_biz === "EXPIRED" ||
        quest.quest_business?.status_biz === "COMPLETED" ||
        (quest.quest_business?.expire_time &&
          new Date(quest.quest_business.expire_time.slice(0, 23)) < nowDate);

      if (isQuestFull || isQuestExpired) {
        const codeParam = referralCode ? `&code=${referralCode}` : "";
        navigate(
          `/register?from=qrcode&location_id=${locationId}&quest_id=${quest.id}${codeParam}`,
        );
        return;
      }

      setSelectedQuestId(quest.id);
      questDetailDialogRef.current?.open();
    } else {
      setSelectedQuestId(quest.id);
      questDetailDialogRef.current?.open();
    }
  };

  const handleCloseQuestDialog = () => {
    questDetailDialogRef.current?.close();
    setSelectedQuestId(null);
  };

  const introductionQuestTypes = ["INTRODUCE", "DEEP_DIVE"];
  const isIntroCompleted = quests.some(
    (quest) =>
      introductionQuestTypes.includes(quest.quest_business.quest_type) &&
      quest.consumer_status === "COMPLETED",
  );

  // const questWithThumbnail =
  //   quests.find(
  //     (quest) =>
  //       quest.thumbnails &&
  //       Array.isArray(quest.thumbnails) &&
  //       quest.thumbnails.length > 0 &&
  //       quest.thumbnails.some((thumbnail) => thumbnail.file_path)
  //   ) || firstQuest;

  const companyName = firstQuest.quest_business?.business?.company_name;
  const address = firstQuest.location?.address || "";
  const locationName = firstQuest.location?.name || "";
  const phone = firstQuest.quest_business?.business?.phone || "";
  const handleGoBack = () => {
    const businessId = location.state?.businessId || null;
    if (businessId) {
      navigate(`/quest/business/${businessId}`);
      return;
    } else {
      navigate(`/quest`);
    }
  };

  const handleOpenMaps = () => {
    const latitude = firstQuest?.location?.latitude || 1.3048205133757569;
    const longitude = firstQuest?.location?.longitude || 103.83302396479785;

    // if (!latitude || !longitude) {
    //   toastUtils.error(t("quest.questDetails.locationNotAvailable"));
    //   return;
    // }

    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    const appleMapsUrl = `http://maps.apple.com/?q=${latitude},${longitude}&ll=${latitude},${longitude}`;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      const link = document.createElement("a");
      link.href = appleMapsUrl;
      link.click();

      setTimeout(() => {
        if (document.hasFocus()) {
          window.open(googleMapsUrl, "_blank");
        }
      }, 1500);
    } else if (/android/i.test(userAgent)) {
      window.open(googleMapsUrl, "_blank");
    } else {
      window.open(googleMapsUrl, "_blank");
    }
  };

  const groupByHours = () => {
    const workingWeek = firstQuest.quest_business?.business.working_week || [];

    if (!Array.isArray(workingWeek) || workingWeek.length === 0) {
      return [];
    }

    const weekdayOrder = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    const dayAbbrevMap = {
      Monday: "Mon",
      Tuesday: "Tues",
      Wednesday: "Wed",
      Thursday: "Thu",
      Friday: "Fri",
      Saturday: "Sat",
      Sunday: "Sun",
    };
    const abbrev = (name) => dayAbbrevMap[name] || name;

    const sortByWeekday = (a, b) =>
      weekdayOrder.indexOf(a.weekday) - weekdayOrder.indexOf(b.weekday);

    const normalizeDayKey = (day) => {
      if (day.is_closed) return "closed";
      const ranges = Array.isArray(day.working_day) ? day.working_day : [];
      const normalized = ranges
        .map(
          (r) =>
            `${r.start_at?.slice(0, 5) || ""}-${r.end_at?.slice(0, 5) || ""}`,
        )
        .join("|");
      return normalized;
    };

    const sortedWeek = [...workingWeek].sort(sortByWeekday);

    const contiguousGroups = [];
    let run = [sortedWeek[0]];
    for (let i = 1; i < sortedWeek.length; i++) {
      const prev = sortedWeek[i - 1];
      const curr = sortedWeek[i];
      if (normalizeDayKey(prev) === normalizeDayKey(curr)) {
        run.push(curr);
      } else {
        contiguousGroups.push(run);
        run = [curr];
      }
    }
    contiguousGroups.push(run);

    const uniqueScheduleCount = new Set(
      sortedWeek.map((d) => normalizeDayKey(d)),
    ).size;

    const formatToAmPm = (time) => {
      if (!time) return "N/A";
      const [hh, mm] = time.slice(0, 5).split(":");
      let hours = parseInt(hh, 10);
      const minutes = mm || "00";
      const period = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      if (hours === 0) hours = 12;
      if (minutes === "00") {
        return `${hours}${period}`;
      }
      return `${hours}.${minutes} ${period}`;
    };

    const joinRanges = (day) => {
      if (day.is_closed) return "Closed";
      const ranges = Array.isArray(day.working_day) ? day.working_day : [];
      return ranges
        .map((r) => `${formatToAmPm(r.start_at)} - ${formatToAmPm(r.end_at)}`)
        .join("\n");
    };

    const formattedGroups = contiguousGroups.map((group) => {
      const days = group.map((d) => d.weekday);
      const isAllUniform = sortedWeek.length > 0 && uniqueScheduleCount === 1;

      let dayLabel = days.map(abbrev).join(" - ");
      if (isAllUniform) {
        dayLabel = "Mon - Sun";
      } else if (
        days.length === 5 &&
        days.join(",") === "Monday,Tuesday,Wednesday,Thursday,Friday"
      ) {
        dayLabel = "Mon - Fri";
      } else if (days.length >= 2) {
        const indices = days.map((d) => weekdayOrder.indexOf(d));
        const isConsecutive = indices.every((idx, i) =>
          i === 0 ? true : idx === indices[i - 1] + 1,
        );
        if (isConsecutive) {
          dayLabel = `${abbrev(days[0])} - ${abbrev(days[days.length - 1])}`;
        }
      }

      return {
        days: dayLabel,
        times: joinRanges(group[0]),
      };
    });

    return formattedGroups;
  };

  const formattedGroups = groupByHours();

  const coverImage = firstQuest?.thumbnails?.[0]?.file_path
    ? `${process.env.REACT_APP_URL_IMAGE}/${firstQuest.thumbnails[0].file_path}`
    : "https://t4.ftcdn.net/jpg/05/17/53/57/360_F_517535712_q7f9QC9X6TQxWi6xYZZbMmw5cnLMr279.jpg";

  const isAllQuestsFinished =
    quests.length > 0 &&
    quests.every(
      (quest) =>
        Array.isArray(quest?.participants) &&
        quest.participants.length > 0 &&
        quest.participants[quest.participants.length - 1]?.status ===
          "COMPLETED",
    ) &&
    isParticipantsCompleted === true;

  return (
    <div className="section-content flex flex-col mx-auto w-full items-center max-w-[480px] relative">
      <div>
        <div className="h-[100px] absolute inset-0 top-0">
          <img
            className="w-full h-[100px] object-cover"
            src={coverImage}
            alt={companyName}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://t4.ftcdn.net/jpg/05/17/53/57/360_F_517535712_q7f9QC9X6TQxWi6xYZZbMmw5cnLMr279.jpg";
            }}
          />
        </div>
        <div className="h-[100px]" />
      </div>
      <div className="absolute top-5 left-5 z-30 size-10 flex items-center justify-center ">
        <span
          onClick={handleGoBack}
          className={`icon icon-arrow-left text-white text-[18px] cursor-pointer drop-shadow-svg_shadow`}
        />
      </div>
      <div className="container flex justify-between p-3 shadow-[0_0_15px_0_#0000001A] rounded-md -translate-y-7 bg-white">
        <div className="flex flex-1 gap-[18px] items-center truncate">
          <img
            src={`${process.env.REACT_APP_URL_IMAGE}/${firstQuest?.quest_business?.business?.avatar_data?.file_path}`}
            className="size-[70px] rounded-[6px] border border-light-grey object-cover"
            alt=""
            onClick={() =>
              navigate(`/quest/business/${firstQuest.location.business_id}`)
            }
          />
          <div className="flex flex-col gap-1 truncate">
            <p className="text-2xl font-medium truncate">{companyName}</p>
            <p
              onClick={() => locationDialogRef.current.open()}
              className="[&>span]:text-base [&>span]:text-mid-gray flex gap-1.5 cursor-pointer"
            >
              <span className="icon icon-location" />
              <span className="font-medium">
                {locationName || "Location Name"}
              </span>
            </p>
          </div>
        </div>
        <div
          className="m-2 align-baseline"
          onClick={() => handleFavoriteLocation(locationId)}
        >
          <span
            className={`icon text-xl ${
              favorite
                ? "icon-heart-active text-primary"
                : "icon-heart text-mid-gray"
            }`}
          />
        </div>
      </div>

      <div className="container w-full flex flex-col gap-6 pb-6">
        {isAllQuestsFinished
          ? showCompletedBanner && (
              <CompletedAllQuest onClose={handleCloseCompletedBanner} />
            )
          : showTipsReward && <TipsReward onClose={handleCloseTipsReward} />}

        <div className="flex flex-col gap-3">
          {quests.length === 0 && !isFetchingPerLocation && !isFetchingAuth ? (
            <div className="flex flex-col justify-center items-center text-center mt-4 gap-6 w-full">
              <div className="flex justify-center items-center">
                <img
                  src={images.ReviewReceiptImage}
                  alt="no-quests"
                  className="w-[170px]"
                />
              </div>
              <div className="flex flex-col justify-center font-medium text-2xl w-full text-center text-[#253FF6]">
                <p>{t("home.wereSorry")}</p>
              </div>
              <div className="text-[#333333] text-lg">
                <p>{t("home.thereAreNoQuestsPerLocation")}</p>
              </div>
              <div className="text-[#A0A0A0] text-sm">
                <p>{t("home.pleaseTryAgainSoon")}</p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-6">
              {categories.map((category, index) => (
                <QuestCategorySection
                  key={category.id}
                  title={category.title}
                  quests={category.data}
                  accessToken={accessToken}
                  isIntroCompleted={isIntroCompleted}
                  handleQuestClick={handleQuestClick}
                  handleQuestSaved={handleQuestSaved}
                  isParticipantsCompleted={isParticipantsCompleted}
                  showConnectors={index === 0}
                  onEndReached={handleHorizontalEndReached}
                  hasMore={hasMore}
                  isLoading={isFetchingPerLocation || isFetchingAuth}
                />
              ))}
            </div>
          )}

          {(isFetchingPerLocation ||
            isFetchingAuth ||
            isFavoriteLoading ||
            isQrCodeTracking) && (
            <div className="text-center py-4">
              <LoadingCommon statusLoading={true} />
            </div>
          )}
        </div>

        {(isFetchingPerLocation ||
          isFetchingAuth ||
          isFavoriteLoading ||
          isQrCodeTracking) && (
          <div className="text-center py-4">
            <LoadingCommon statusLoading={true} />
          </div>
        )}
      </div>

      <CommonModal
        ref={infomationBizModalRef}
        classNameText="text-[#201D1B] font-medium text-lg"
        canClickOverLay={false}
        showCloseIcon={true}
        closeIcon={images.CloseModalIconGray}
      >
        <div className="flex flex-col justify-start items-start gap-[6px] w-full">
          <div className="flex flex-col justify-start items-start gap-[6px]">
            <p className="text-[#333333] text-[16px] font-medium">
              {companyName}
            </p>
            {locationName && (
              <div className="flex flex-row items-start gap-1 text-start">
                <img
                  src={images.MapPinIcon}
                  alt="map-pin-icon"
                  className="h-[18px] w-[18px]"
                />
                <span className="text-base text-[#A0A0A0] leading-none">
                  {locationName}
                </span>
              </div>
            )}
          </div>

          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={defaultProps.zoom}
          >
            <Marker
              position={mapCenter}
              icon={{
                url: images.DotmapBlueIcon,
                scaledSize: new window.google.maps.Size(40, 40),
              }}
            />
          </GoogleMap>

          <div className="flex flex-col justify-between w-full gap-3 mt-2">
            <div className="flex justify-start text-start gap-1.5 ">
              <img src={images.SendIcon} alt="" className="w-[18px] h-[18px]" />
              <p className="text-[#A0A0A0]">{address}</p>
            </div>
            {phone && (
              <div className="flex justify-start text-start gap-1.5 ">
                <img
                  src={images.PhoneIconSVG}
                  alt=""
                  className="w-[18px] h-[18px]"
                />
                <p className="text-[#A0A0A0]">{phone}</p>
              </div>
            )}

            <div className="w-full">
              <div className="flex flex-col gap-1">
                {formattedGroups.length > 0 &&
                  formattedGroups.map((group, index) => (
                    <div
                      key={index}
                      className="flex justify-start gap-2 text-[#A0A0A0] text-sm"
                    >
                      <img
                        src={images.OclockIconSVG}
                        className="w-[18px] h-[18px]"
                        alt=""
                      />
                      <span className="text-left">{group.days}:</span>
                      <span className="text-left whitespace-pre-line">
                        {group.times}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
            <div
              className="flex justify-start gap-1.5 cursor-pointer"
              onClick={handleOpenMaps}
            >
              <img
                src={images.MapIcon2Blue}
                alt=""
                className="w-[18px] h-[18px]"
              />
              <p className="text-[#253FF6] text-sm font-medium">
                {t("quest.questDetails.openInMaps")}
              </p>
            </div>
          </div>
        </div>
      </CommonModal>
      <Dialog ref={questDetailDialogRef} hiddenCloseButton={true}>
        {selectedQuestId && (
          <QuestDetails
            questId={selectedQuestId}
            // isPopup={true}
            onClose={handleCloseQuestDialog}
            onStartQuest={handleParentStartQuest}
          />
        )}
      </Dialog>
      <Dialog ref={locationDialogRef} hiddenCloseButton={true}>
        <div
          className={cn(
            "flex flex-col justify-center items-start   bg-white gap-3 sm:gap-6",
          )}
        >
          <div className="flex justify-between gap-2 xs:gap-3 w-full">
            <div className="flex flex-col gap-1 xs:gap-3 truncate">
              <p className="text-2xl text-[#253FF6] font-bold truncate text-left text-wrap">
                {companyName}
              </p>
              <p className="[&>span]:text-base [&>span]:text-mid-gray flex gap-1.5">
                <span className="icon icon-location text-base" />
                <span className="font-medium">
                  {locationName || "Location Name"}
                </span>
              </p>
            </div>
            <div>
              <button
                onClick={() => locationDialogRef.current.close()}
                className="w-[24px] h-[24px] xs:w-[30px] xs:h-[30px] flex items-center justify-center hover:bg-gray-100 transition-colors duration-200 z-10"
                aria-label="Close modal"
              >
                <img
                  src={images.CloseModalIconGray}
                  className="w-4 h-4 xs:w-5 xs:h-5"
                  alt="Close"
                />
              </button>
            </div>
          </div>
          <div className="h-[200px] w-full rounded-md overflow-hidden relative">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={mapCenter}
              zoom={defaultProps.zoom}
            >
              <Marker
                position={mapCenter}
                icon={{
                  url: images.DotmapBlueIcon,
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
              />
            </GoogleMap>
          </div>

          <div className="flex flex-col gap-1 xs:gap-3 items-start self-stretch ">
            <div className="flex justify-start text-start gap-1.5 ">
              <span className="icon icon-navigation text-base text-[#A0A0A0]" />
              <p className="text-[#A0A0A0] font-medium text-base">{address}</p>
            </div>
            {phone && (
              <div className="flex justify-start text-start gap-1.5 ">
                <span className="icon icon-phone text-base text-[#A0A0A0]" />

                <p className="text-[#A0A0A0] font-medium text-base">{phone}</p>
              </div>
            )}

            <div className="w-full flex gap-1.5">
              <span className="icon icon-clock text-base text-[#A0A0A0]" />

              <div className="flex flex-col gap-1">
                {formattedGroups.length > 0 &&
                  formattedGroups.map((group, index) => (
                    <div
                      key={index}
                      className="flex justify-start gap-2 text-[#A0A0A0] text-sm"
                    >
                      <span className="text-left text-[#A0A0A0] font-medium text-base">
                        {group.days}:
                      </span>
                      <span className="text-left text-[#A0A0A0] font-medium text-base whitespace-pre-line">
                        {group.times}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
            <div
              className="flex justify-start gap-1.5 cursor-pointer"
              onClick={handleOpenMaps}
            >
              <span className="icon icon-map text-base text-[#253FF6]" />

              <p className="text-[#253FF6] text-sm font-medium">
                {t("quest.questDetails.openInMaps")}
              </p>
            </div>
          </div>
        </div>
      </Dialog>

      <CommonModal
        ref={loadingQuestModalRef}
        // ref={questDetailDialogRef}
        classNameText="text-[14px] font-medium text-[#253FF6]"
        showCloseIcon={false}
        canClickOverLay={false}
        classNameModal="p-6"
        classNameBodyModal="bg-[#ECEEFF] p-0"
      >
        <BodyModalLoading
          duration="5s"
          loadingText={t("quest.questDetails.loadingQuest")}
          text={t("quest.questDetails.rallyTips")}
          imageSrc={images.ReviewingQuestCompletedImage}
          tipsText1={t("quest.questDetails.honestyPays")}
          iconText1="💰"
          tipsText2={t("quest.questDetails.vaguenessDoesnt")}
          iconText2="❌"
          conclusionText={t("quest.questDetails.beSpecificEarnMore")}
          animationSrc={"write-and-earn.json"}
        />
      </CommonModal>
      <Dialog
        ref={validateInfomationModelRef}
        classNameText="text-[#201D1B] font-medium text-lg"
        className="!overflow-visible !max-h-none h-auto"
      >
        {showValidationModal && (
          <div className="flex flex-col justify-start items-center gap-[18px]">
            <h2 className="text-[#253FF6] text-base xs:text-xl text-center leading-[2.5rem] font-bold whitespace-pre-line">
              {t("onBoard.questMadeForYou")}
            </h2>
            <p className="text-xs xs:text-sm font-medium text-center text-[#253FF6] whitespace-pre-line">
              {renderWithBold(t("onBoard.shareYourInfo"), {
                classNameText: "text-[#253FF6]",
              })}
            </p>

            <div className="flex flex-col items-start w-full">
              <div className="flex items-center border border-gray-300 rounded-lg px-2 py-1.5  xs:px-4 xs:py-3 w-full">
                <img
                  src={images.CalendarIcon2}
                  alt="Icon"
                  className="xs:w-5 xs:h-5 w-3 h-3 mr-3"
                />
                <input
                  type="number"
                  name="age"
                  value={formData.age}
                  onChange={handleInputChange}
                  placeholder={t("onBoard.age")}
                  className="w-full px-2 py-[2px] xs:px-4 xs:py-1 text-xs xs:text-base focus:outline-none focus:border-transparent"
                />
              </div>
              {errors.age && (
                <p className="text-red-500 text-xs xs:text-sm mt-1">
                  {errors.age}
                </p>
              )}
            </div>

            <div className="flex flex-col items-start w-full">
              <div className="flex items-center border border-gray-300 rounded-lg px-2 py-1.5  xs:px-4 xs:py-3  w-full">
                <img
                  src={images.User3Icon}
                  alt="Icon"
                  className="xs:w-5 xs:h-5 w-3 h-3 mr-3"
                />
                <CustomSelect
                  options={optionsAge}
                  value={formData.gender}
                  onChange={handleSelectChange}
                  placeholder={t("onBoard.gender")}
                  icon={""}
                  className="px-2 py-[2px] xs:px-4 xs:py-1 "
                  classNameTextSelect="text-xs xs:text-base"
                  classNameOption="px-2 py-1.5  xs:px-4 xs:py-3"
                />
              </div>
              {errors.gender && (
                <p className="text-red-500 text-xs xs:text-sm mt-1">
                  {errors.gender}
                </p>
              )}
            </div>

            <button
              className={`w-full px-2 py-1.5  xs:px-4 xs:py-3 text-white rounded-lg text-sm xs:text-lg font-medium transition-all ${
                isSubmitting
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#253FF6] hover:bg-[#1e32cc]"
              }`}
              onClick={handleValidateInformation}
              disabled={isSubmitting}
            >
              {isSubmitting ? <LoadingSpinner size="xs" /> : t("base.next")}
            </button>
          </div>
        )}
      </Dialog>
    </div>
  );
};

export default QuestPerLocation;
